import { Subscription, SubscriptionApiInterface } from "@syadem/kairos-subscription-js";
import { AppStore } from "../store";
import { Service } from "./service";
import { Success } from "../actionResult";

interface Payload {
  organizationId: string;
}

export class StopSubscriptionCancellationService implements Service<Payload, Subscription> {
  constructor(
    private readonly store: AppStore,
    private readonly subscriptionApi: SubscriptionApiInterface
  ) {}

  async call({ organizationId }: Payload): Promise<Success<Subscription>> {
    const subscription = await this.subscriptionApi.stopSubscriptionCancellation(organizationId);

    this.store.setState((state) => {
      if (state.subscriptionOrganizations && state.subscriptionOrganizations[organizationId]) {
        return {
          ...state,
          subscriptionOrganizations: {
            ...state.subscriptionOrganizations,
            [organizationId]: {
              ...state.subscriptionOrganizations[organizationId],
              subscription
            }
          }
        };
      } else {
        return {
          ...state,
          subscriptionOrganizations: {
            ...(state.subscriptionOrganizations || {}),
            [organizationId]: {
              id: organizationId,
              invoices: [],
              defaultPaymentMethod: null,
              subscription
            }
          }
        };
      }
    })

    return {
      type: "success",
      value: subscription
    };
  }
}
